export default __webpack_public_path__ + "static/media/c_wdt_c_0.82055e11.mp3";